import React from 'react';

function AlertsDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Callout (inline warning)</div>
        <div
          className='callout'
          style={{ width: '100%' }}
        >
          Deleting this office will unassign <b>14 evaluators</b>. This cannot be undone.
        </div>
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Announcement banners (Home pattern, severity 1/2/3)</div>
        <div style={{ width: '100%', display: 'grid', gap: 8 }}>
          <div
            className='home-announce crit'
            role='status'
          >
            <span className='an-ic'>
              <i className='fa-solid fa-circle-exclamation' />
            </span>
            <div className='an-body'>
              <span className='an-title'>Critical</span>
              <span className='an-text'>Payment export is paused until further notice.</span>
            </div>
          </div>
          <div
            className='home-announce'
            role='status'
          >
            <span className='an-ic'>
              <i className='fa-solid fa-triangle-exclamation' />
            </span>
            <div className='an-body'>
              <span className='an-title'>Warning</span>
              <span className='an-text'>Scheduled maintenance on Saturday 22:00–23:00 CET.</span>
            </div>
          </div>
          <div
            className='home-announce info'
            role='status'
          >
            <span className='an-ic'>
              <i className='fa-solid fa-circle-info' />
            </span>
            <div className='an-body'>
              <span className='an-title'>Info</span>
              <span className='an-text'>New reporting dashboard is available under Operations.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const alertsDemo = {
  id: 'alerts',
  title: 'Alerts & banners',
  category: 'Basics',
  importPath: 'src/Css/design-system/bravo-ds.css (.callout) + bravo-app.css (.home-announce)',
  notes: [
    '.callout is the inline gold warning block used inside modals/forms.',
    '.home-announce (+ .crit / .info) is the Home announcement banner; severity mapping lives in homeHelpers.ts (1=Critical, 2=Warning, 3=Info).',
    'For transient feedback use the toast system (ErrorMessage.SetErrorMessage / SetNotification / SetSuccessMessage) — see the Toasts entry under Overlays & Editing.',
  ],
  snippet: "<div className='callout'>\n  Deleting this office will unassign <b>14 evaluators</b>.\n</div>",
  render: AlertsDemoComponent,
};
